import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';
import FileResource from './FileResource';
import FileShareResource from './FileShareResource';
import axios from 'axios';

export default class FilesResource extends BaseResource {
  constructor() {
    super({ url: '/api/files' });
  }

  get(id) {
    return super
      .get({ url: `${this.url}/${id}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  getByOid(oid) {
    return super
      .get({ url: `${this.url}/oid/${oid}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  createFolder(params = { name: '', parent: '' }) {
    const urlParams = objectToUrlParams(params);
    return super
      .post({}, { url: `${this.url}/folder${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  file(id) {
    return new FileResource(`${this.url}/${id}`);
  }

  download(oid) {
    return super
      .get({
        url: `${this.url}/oid/${oid}/download?redirect=content`,
        responseType: 'blob',
        headers: {
          'cache-control': 'max-age=3600',
        },
      })
      .then((response) => response)
      .catch((error) => error.response);
  }

  list(params) {
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  listRoot(scope, params) {
    const urlParams = objectToUrlParams(params);
    const options = {
      url: `${this.url}/${scope}/files${urlParams}`,
    };
    return super
      .get(options)
      .then((response) => response)
      .catch((error) => error.response);
  }

  listChildren(id, params = {}) {
    const urlParams = objectToUrlParams(params);
    const options = {
      url: `${this.url}/${id}/files${urlParams}`,
    };
    return super
      .get(options)
      .then((response) => response)
      .catch((error) => error.response);
  }

  listShareBuckets() {
    return super
      .get({
        url: `${this.url}/shared/buckets`,
      })
      .then((response) => response)
      .catch((error) => error.response);
  }

  search(params) {
    const urlParams = objectToUrlParams(params);
    const options = {
      url: `${this.url}/search${urlParams}`,
    };
    return super
      .get(options)
      .then((response) => response)
      .catch((error) => error.response);
  }

  shareableAccounts(params = { query: '', size: 100 }) {
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}/shareable_accounts${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  fileShare(oid) {
    return new FileShareResource(`${this.url}/oid/${oid}`);
  }

  upload(file, parent = '', config = {}) {
    const { name, type } = file;
    const urlParams = objectToUrlParams({ name, content_type: type, parent });
    return super
      .post({}, { url: `${this.url}/upload${urlParams}`, ...config })
      .then((response) => response)
      .catch((error) => error.response);
  }

  uploadFile(url, file, config = {}) {
    return axios
      .put(url, file, {
        headers: {
          'x-ms-blob-type': 'BlockBlob',
          'Content-Type': file.type,
        },
        ...config,
      })
      .then((response) => response)
      .catch((error) => error.response);
  }

  listBin(params = { size: 15, sort: 'last_modified asc' }) {
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}/trash${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }
}
